import React, { createRef, useState } from "react";
import "./MapWrapper.css";
import ModalComponent from "../ModalComponent/ModalComponent";
import SelectComponent from "../SelectComponent/SelectComponent";
import { Expand, DownlaodNew } from "../../IconComponents";
import { downLoadScreenShot } from "../utils";
import { useEffect } from "react";
import CustomMap from "../CustomMap/CustomMap";
import CustomMapForIncident from "../CustomMap/CustomMapForIncidents";
 
const MapWrapperForIncident = (props) => {
  const {
    title, //string
    dropdownOptions, //array
    selectedOption, //string
    onChangeHandler, //function
    containerStyles = {}, //object
    headerStyles = {}, //object
    bodyStyles = {}, //object
    coordinates, // array,
    chooseCoordinates,
    closeMapModal,
  } = props;
 
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const chooseCoordinates1 = (longitude, latitude) => {
    setLongitude(longitude);
    setLatitude(latitude);
  };
 
  useEffect(() => {
    {
      chooseCoordinates && chooseCoordinates1(longitude, latitude);
    }
  }, []);
 
  const ref = createRef();
  const [showExpand, setShowExpand] = useState(false);
  const expandHandler = () => {
    setShowExpand(!showExpand);
  };
 
  const renderMap = () => {
    return (
       (
        <CustomMapForIncident chooseCoordinates={chooseCoordinates}  closeMapModal={closeMapModal} {...props} />
     
      )
    );
  };
 
  return (
    <div className="map__container" style={containerStyles}>
      <div className="map__container--header" style={{
        ...headerStyles, height: "40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {title && <span className="map__header--text">{title}</span>}
        </div>
       
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginLeft: "auto"
        }}>
          <div className="map__container--export">
            <div className="map__container--export--icon cursor-pointer">
              {/* <DownlaodNew
                width="1.2em"
                height="1.2em"
                onClick={() =>
                  downLoadScreenShot(
                    ref, //ref
                    1, //scale
                    "MapView.png", //fileName
                    true //Flag to hide zoom controls
                  )
                }
              /> */}
            </div>
            {/* <div onClick={expandHandler} className="cursor-pointer">
              <Expand fill="#fff" width="1.1em" height="1.1em" />
            </div> */}
          </div>
         
          {/* Device Type dropdown placed at the end */}
          {/* {onChangeHandler && (
            <div style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "10px"
            }}>
              <label style={{
                fontSize: "12px",
                marginRight: "6px",
                color: "white",
                whiteSpace: "nowrap"
              }}>
                Device Type:
              </label>
              <select
                className="category__select"
                style={{
                  backgroundColor: "transparent",
                  color: "white",
                  border: "1px solid white",
                  borderRadius: "4px",
                  padding: "3px 24px 3px 6px",
                  fontWeight: "normal",
                  fontSize: "12px",
                  width: "auto",
                  minWidth: "100px",
                  appearance: "none",
                  backgroundImage: "url('data:image/svg+xml;utf8,<svg fill=\"white\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/><path d=\"M0 0h24v24H0z\" fill=\"none\"/></svg>')",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 5px center",
                  paddingRight: "30px",
                }}
                onChange={onChangeHandler}
                value={selectedOption}>
                {dropdownOptions?.length > 0 &&
                  dropdownOptions.map((item, index) => (
                    <option
                      data-set={item?.id}
                      key={index}
                      value={item?.id}
                      className="option-text">
                      {item.value}
                    </option>
                  ))}
              </select>
            </div>
          )} */}
        </div>
      </div>
 
      <div className="map__container--body" ref={ref} bodyStyles={bodyStyles}>
        {renderMap()}
      </div>
 
      {showExpand && (
        <ModalComponent
          title="Map View"
          show={showExpand}
          handleToggle={expandHandler}
          fullscreen={true}
          component={renderMap()}
        />
      )}
    </div>
  );
};
 
export default MapWrapperForIncident;